import { useRouter } from 'next/router'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import useDynamicTheme from 'apps/Diner/hooks/useDynamicTheme'

interface Props {
  children: JSX.Element
}

const DynamicThemeProvider = ({ children }: Props): JSX.Element => {
  const router = useRouter()
  const { merchantLocationId, venueId } = router.query
  const theme = useDynamicTheme({ venueId, merchantLocationId })

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export default DynamicThemeProvider
